import { call } from 'redux-saga/effects';

export function* retrySaga(endpoint, args = [], retries = 3, delayLength = 20) {
    return yield call(endpoint, ...args);
}
